<div class="marketplace">
  <mat-accordion [displayMode]="'flat'" [multi]="true">
    <mat-expansion-panel hideToggle #panel>
      <mat-expansion-panel-header>
        <div class="marketplace_inner">
          <div class="marketplace_header">
            <div class="d-flex align-items-center nineyard3pl_header">
              <div class="marketplace_icon">
                <img src="assets/images/fbm-order-icon/shipstation-icon.svg" class="img-fluid" />
              </div>
            </div>
            <div class="marketplace_name">
              ShipStation
            </div>
            <div class="marketplace_action">
              <app-button *ngIf="!selectedPortal" [buttonSize]="'action'" [isDisabled]="connections"
                (click)="openAddConnection($event)">Add</app-button>
              <app-button *ngIf="selectedPortal" (click)="openAddConnection($event);" [buttonSize]="'action'">Close
              </app-button>
            </div>
            <div matTooltip="Connected accounts" class="marketplace_count">
              {{ connections?1:0 }}
            </div>
            <div class="marketplace_expand">
              <i class="fal" [ngClass]="{
                    'fa-chevron-down': panel.expanded,
                    'fa-chevron-right': !panel.expanded
                  }"></i>
            </div>
          </div>

          <div class="marketplace_new-portal" (click)="cancelEvent($event)" [hidden]="!selectedPortal">
            <ng-template [cdkPortalOutlet]="selectedPortal" (attached)="attach($event)"></ng-template>
          </div>
        </div>
      </mat-expansion-panel-header>

      <div class="marketplace_body" *ngIf="connections">
        <div>
          <form [formGroup]="form">
            <div class="input-container connection w-100">
              <div class="d-flex align-items-center justify-content-between">
                <label>{{ 'shipstation' | titlecase }}</label><span>
                  <app-button [buttonSize]="'small small-sm'" [buttonStyle]="'underline'" (click)="showDetails()">
                    Details
                  </app-button>
                  <app-button [buttonSize]="'small small-sm'" [buttonStyle]="'text underline'" [buttonColor]="'accent'"
                    (click)="remove()"><i class="far fa-trash-alt ms-3 text-danger"></i>
                  </app-button>
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>